import {isLoggedIn} from '@github-ui/client-env'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export class PreheatIssuesIndexManager {
  async preheat(owner: string, repo: string, source: string): Promise<void> {
    if (!isLoggedIn() || isFeatureEnabled('disable_preheating_for_issues')) return
    if (
      !isFeatureEnabled('issues_index_query_persistence') ||
      !isFeatureEnabled('issues_index_data_router_preheating')
    ) {
      return
    }

    // Lazy so the global nav bundle doesn't include the Issues index query and protobuf runtime.
    const {preheatIssuesIndex} = await import('./issues-index-query')
    return preheatIssuesIndex({owner, repo, source})
  }
}
